import React from "react";
import SEO from "../shared/SEO";
import backImage1 from '../../src/assets/learn-back.png'
import backImage2 from '../../src/assets/create-back.png'
import backImage3 from '../../src/assets/receive-back.png'
import backImage4 from '../../src/assets/connect1-back.png'
import group53 from '../../assets/Group 53.png'
import image1 from '../../assets/learn-front.png'
import image2 from '../../assets/create-front.png'
import image3 from '../../assets/receive-front.png'
import image4 from '../../assets/GetFunded.png'
import createback from '../../assets/createflip.png'
import receiveback from '../../assets/Receiveflip.png'
import getfundedback from '../../assets/GetFundedflip.png'
import learnback from '../../assets/Learnflip.png'
import vectorLeft1 from '../../assets/vector-left-1.png'
import vectorLeft2 from '../../assets/vector-left-2.png'
import vectorLeft3 from '../../assets/vector-left-3.png'
import vectorRight1 from '../../assets/vector-right-1.png'
import vectorRight2 from '../../assets/vector-right-2.png'
import vectorRight3 from '../../assets/vector-right-3.png'
import vectorCenter1 from '../../assets/Vector-center-1.png'
import vectorCenter2 from '../../assets/Vector-center-2.png'
import vectorCenter3 from '../../assets/vector-center-3.png'
import layerBlur from '../../assets/layer-blur.png'
import group48 from '../../src/assets/Group 48.png'
import steps from '../../assets/Steps.png'
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import shape1 from "../../assets/special1.svg";
import shape2 from "../../assets/special2.svg";
import step1 from "../../assets/Group 55.png"
import step2 from "../../assets/Group 56.png"
import step3 from "../../assets/Group 57.png"
import step4 from "../../assets/Group 58.png"
import f6sNetworkPartnerWhite from "../../assets/F6S-network-partner-white.svg"

const faqItems = [
  {
    question: "Who can join The Orcas Valley?",
    answer:
      "Our services are tailored for early-stage startups and entrepreneurs with innovative ideas.",
  },
  {
    question: "How does the funding competition work?",
    answer:
      "Startups can apply to compete for up to $100K in funding through our angel investor network. The top contenders will be picked over two seasonal batches, one in winter and another in summer.",
  },
  {
    question: "Is the pitch deck generator easy to use?",
    answer:
      "Absolutely! Our AI-powered tool is intuitive and designed for entrepreneurs of all experience levels.",
  },
  {
    question: "What if I have no startup or business experience?",
    answer:
      "No problem. Orcas Valley is also built for beginners. We guide you step-by-step, starting from zero experience.",
  },
  {
    question: "Do I need a business idea before joining?",
    answer:
      "Not at all. The Orca Blueprint will help you find and develop ideas that match your interests and goals.",
  },
  {
    question: "Can I still benefit if I’m just exploring entrepreneurship?",
    answer:
      "Absolutely. Our platform helps you explore entrepreneurship risk-free, so you can decide if it’s right for you.",
  },
];
const data = [
    {
      img: shape1,
      text: "The Orca Blueprint: A startup guide to building and scaling your business with expert insights.",
    },
    {
      img: shape2,
      text: "Access to our AI-powered pitch deck generator that gets investors to say Yes.",
    },
    {
      img: shape1,
      text: "Get feedback, scores, and tailored angel investor connections to boost your funding success.",
    },
     {
      img: shape2,
      text: "A chance to compete for angel investments by the Orcas Valley.",
    },
  ];
// import bgimage1 from "../../src/assets/StartUpAcc 1.png"
export default function StartupAccelerator() {
  const benefits = [
    {
      id: 1,
      front: image1,
      back: learnback,
      title: "Learn",
      description:
        "Gain insight through our eBook: The Orca Blueprint.",
    },
    {
      id: 2,
      front: image2,
      back: createback,
      title: "Create",
      description:
        "Create investor-ready pitch decks effortlessly.",
    },
    {
      id: 3,
      front: image3,
      back: receiveback,
      title: "Receive",
      description:
        "Receive professional feedback to refine your pitch.",
    },
    {
      id: 4,
      front: image4,
      back: getfundedback,
      title: "Get Funded",
      description:
        "Compete for angel investments with up to $100K in funding opportunities over two seasonal batches per year.",
    },

  ];
   const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index:any) => {
    setOpenIndex(openIndex === index ? null : index);
  };
    const navigate = useNavigate();
  return (
   
    <div className="bg-white">
      <SEO
        title="Startup Accelerator | Learn, Build, Pitch and Get Funded"
        description="Join a startup accelerator built for first-time founders. Learn with The Orca Blueprint, pitch with AI tools, and compete for angel funding."
        url="https://orcasvalley.web.app/startup-accelerator"
        keywords="startup accelerator, first-time founders, orca blueprint, startup program, entrepreneur accelerator, business accelerator"
      />
           <Navbar />
      {/* Hero Section */}

      <header className="relative text-white h-[85vh] flex items-center px-6 sm:px-10 lg:px-20">
  {/* Background Image */}
  <div className="absolute inset-0 px-6 md:px-10 py-2 md:py-0">
    <div 
      className="w-full h-full bg-cover bg-center rounded-xl"
      style={{ backgroundImage: "url('/startup-bg.png')" }}
    ></div>
  </div>



  {/* Content (Text on Top of Image) */}
  <div className="relative z-10 max-w-2xl px-6 sm:px-10 text-center sm:text-left mt-32 sm:mt-44">
    <h1 className="text-4xl sm:text-6xl font-medium leading-tight">
      Startup Accelerator: Learn, Build, <br className="hidden sm:block" /> Pitch and Get Funded
    </h1>
    <p className="mt-4 text-base sm:text-lg font-light text-gray-300">
    Join a startup accelerator built for first-time founders. Learn with The Orca Blueprint, 
    pitch with AI tools, and compete for angel funding opportunities.
    </p>
    
    {/* Buttons */}
    <div className="mt-6 flex flex-col sm:flex-row items-center sm:space-x-3 space-y-3 sm:space-y-0">
      {/* Apply Now Button */}
      <a href="https://www.f6s.com/orcas-valley-founder-cohort-winter-2026/apply"
        target="_blank"
        rel="noopener noreferrer"
      className="px-6 py-2 bg-white text-black hover:bg-[#2CFFCC] rounded-full font-light flex items-center space-x-2 shadow-md">
        <span>Apply Now</span> 
        <span className="text-lg">→</span>
      </a>

      {/* Separator (Hidden on Mobile) */}
      <span className="hidden sm:block text-gray-400 text-lg">•</span>

      {/* Become an Orca Button */}
      <button className="text-gray-300 font-light">
        Become an Orca
      </button>
    </div>
  </div>

  {/* Side Text (Vertical) */}
  <div className="absolute top-6 left-3 xs:left-2 sm:top-10 sm:left-6 md:left-10 z-20 px-5 flex flex-col items-center text-gray-300 text-lg tracking-widest  sm:flex">
    <div className="border-l-2 border-gray-300 h-6 sm:h-10 mb-1 sm:mb-2"></div>
    <p className="flex flex-col text-center text-xs">
    <span>T</span>
      <span>H</span>
      <span>E</span>
      <br />
      <span>O</span>
      <span>R</span>
      <span>C</span>
      <span>A</span>
      <span>S</span>
      <br />
      <span>W</span>
      <span>A</span>
      <span>Y</span>
    </p>
  </div>
</header>



      

{/* Comprehensive Package Section */}
<section
  style={{
    backgroundImage: "url('/Ellipse 3.png')",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top left",
  }}
  className="w-full py-16 px-6 sm:px-10 lg:px-20 flex flex-col lg:flex-row items-center lg:items-center justify-between gap-16"
>
  <div className="w-full lg:w-[40%] text-left">
    <h2 className="text-gray-700 text-xl sm:text-2xl font-light">
      Comprehensive Package
    </h2>
    <p className="text-[rgba(0,0,0,0.64)] text-3xl sm:text-5xl font-light leading-snug mt-3">
      A full-service package designed to <br />
      <span className="text-teal-500">
        guide startups <br className="hidden sm:block" />
        from ideation to funding.
      </span>
    </p>

    <p className="mt-4 text-lg text-[rgba(0,0,0,0.64)]">
      Just a one-time payment of $299 with no hidden fees and no equity taken
      to join. Your startup success stays yours.
    </p>

    <div className="flex flex-col items-start mt-6">
      <a
        href="https://www.f6s.com/orcas-valley-founder-cohort-winter-2026/apply"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#02C4A1] hover:bg-[#072928] text-white font-medium px-6 py-3 rounded-full flex items-center gap-2 hover:bg-[#029C85] transition duration-300 w-full sm:w-auto justify-center"
      >
        Apply Now
        <span className="text-xl">➝</span>
      </a>
      <p className="text-[rgba(0,0,0,0.64)] mt-2 text-lg">
        Become an Orca. Winter Batch.
      </p>
    </div>
  </div>

  <div className="w-full lg:w-[50%] flex justify-center">
    <img
      src={group53}
      alt="Comprehensive Package Details"
      className="w-full max-w-[400px] sm:max-w-[80%] md:max-w-md lg:max-w-[90%] h-auto"
    />
  </div>
</section>









{/* Key Benefits */}
<section className="text-center py-8 lg:py-16">
  {/* Section Header */}
  <div className="flex items-center justify-center mb-8 relative">
    <div className="w-full max-w-6xl flex items-center">
      <div className="flex-1 h-[1px] bg-gradient-to-r from-transparent via-green-300 to-green-300"></div>
      <h3 className="text-3xl sm:text-4xl font-light px-4 whitespace-nowrap">Key Benefits</h3>
      <div className="flex-1 h-[1px] bg-gradient-to-l from-transparent via-green-300 to-green-300"></div>
    </div>
  </div>

  {/* Benefits Grid */}
  <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-6xl mx-auto px-4">
    {benefits.map((benefit) => (
      <div
        key={benefit.id}
        className="relative group bg-white rounded-[30px] shadow-md  h-64  w-full sm:w-60 overflow-hidden"
      >
        {/* Front Image (Default View) */}
        <img
          src={benefit.front}
          alt="Front"
          className="h-full w-full object-contain rounded-[20px] absolute inset-0 transition-opacity duration-500 group-hover:opacity-0"
        />

        {/* Back Image with Text (Appears on Hover) */}
        <div className="absolute inset-0 flex flex-col justify-start text-left bg-opacity-90 opacity-0 transition-opacity duration-500 group-hover:opacity-100 px-2 py-0 rounded-[30px]">
          <img
            src={benefit.back}
            alt="Back"
            className="h-full w-full object-cover absolute inset-0 rounded-[30px]"
          />
          
          {/* Text Content */}
          <div className="relative flex flex-col h-full justify-start gap-20 z-10 px-3 py-0 sm:px-4 sm:py-4 text-gray-700 font-light">
            <h3 className="text-lg sm:text-xl font-normal mb-2">{benefit.title}</h3>
            <p className="text-xs sm:text-sm mt-4 ">{benefit.description}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</section>


<section className="py-20 px-2 lg:px-6 text-center">
  {/* Main Heading */}
 <section className="w-full max-w-7xl mx-auto px-6 sm:px-10 md:px-5 py-12 flex justify-between items-center">
  <h2 className="text-gray-700 text-xl sm:text-2xl md:text-4xl font-light max-w-[60%] text-left">
    Ready to Learn, Build,<br />Pitch, and{' '}
    <span className="text-teal-500 cursor-pointer">Get Funded?</span>
  </h2>
  {/* <p className="text-gray-500 text-sm sm:text-xl md:text-2xl max-w-[35%] text-left">
    For a one-time fee <br /> of ${'{Amount}'}, you’ll receive.
  </p> */}
</section>



  {/* Special Section */}
 <section className="w-full bg-white px-3 py-12 lg:px-0 lg:py-20 text-center">
      {/* Heading */}
      <div className="px-6 md:px-36">
            <h3 className="relative text-3xl md:text-4xl font-light text-gray-800 text-left">
              What makes <br />
              us <span className="text-[#02C4A1]">special?</span>
            </h3>
          </div>

      {/* Container grid */}
      <div className="flex flex-col w-full lg:flex-row lg:justify-between items-center gap-4">
        {data.map((item, idx) => (
          <div
            key={idx}
            className={`relative w-[95%]  xs:w-[80%]  md:w-[50%] lg:w-[25%] h-[40vh]  xs:h-[50vh] sm:h-[50vh] md:h-[52vh] lg:h-[42vh] flex items-center justify-center text-center ${idx === 0 ? 'mt-0' : idx === 1 ? '-mt-0' :  idx==3?'-mt-0':'-mt-24'}  ${ idx === 2 ? 'sm:-mt-24' : idx==3?'sm:-mt-0': 'sm:-mt-2'} lg:-mt-0 `}
          >
            {/* SVG as background */}
            <img
              src={item.img}
              alt="Shape"
              className="absolute inset-0 w-full h-full object-cover sm:object-cover"
            />
            <p className="relative z-10 max-w-[60%] sm:max-w-[70%] text-gray-800 font-normal leading-relaxed px-6 text-xs md:text-sm">
              {item.text}
            </p>
          </div>
        ))}
      </div>
    </section>




  {/* How to Apply Section */}
  <div className="mt-14 text-left px-20">
    <h3 className="text-3xl sm:text-4xl font-light">
      How to <span className="text-[#02C4A1]">apply?</span>
    </h3>
  </div>

  {/* Group48 Image - Centered */}
  <div className="hidden sm:block mt-8 flex justify-center">
    <img src={steps} alt="Group 48 Steps" className="w-full lg:max-w-[95%] mx-auto" />
  </div>
  <div className="block sm:hidden flex flex-col gap-6">
  <div className="flex justify-end">
    <img src={step1} alt="Step 1" className="w-[80%]" />
  </div>
  <div className="flex justify-start">
    <img src={step2} alt="Step 2" className="w-[80%]" />
  </div>
  <div className="flex justify-end">
    <img src={step3} alt="Step 3" className="w-[80%]" />
  </div>
  <div className="flex justify-start">
    <img src={step4} alt="Step 4" className="w-[80%]" />
  </div>
</div>

</section>





{/* FAQ Section */}
<section className="py-16 px-0  sm:px-8 max-w-[100%] sm:max-w-[88%] mx-5 sm:mx-14">
      <h2 className="text-left text-3xl font-light mb-8">
        Frequently Asked <span className="text-[#02C4A1]">Questions!</span>
      </h2>

      <div className="divide-y divide-gray-300">
        {faqItems.map((item, index) => (
          <div key={index} className="py-4">
            <button
            
              type="submit"
              onClick={() => toggleIndex(index)}
              className="w-full text-left font-normal text-xl flex justify-between items-center cursor-pointer focus:outline-none"
              aria-expanded={openIndex === index}
              aria-controls={`faq-${index}-content`}
              id={`faq-${index}-header`}
            >
              {item.question}
              <span className="text-xl">{openIndex === index ? "−" : "+"}</span>
            </button>
            {openIndex === index && (
              <p
                id={`faq-${index}-content`}
                aria-labelledby={`faq-${index}-header`}
                className="mt-2 font-light text-lg leading-relaxed max-w-[600px]"
              >
                {item.answer}
              </p>
            )}
          </div>
        ))}
      </div>
    </section>


      {/* Footer */}
      <Footer />


    </div>
  );
}
